import { render, staticRenderFns } from "./OrganisationSignUp.vue?vue&type=template&id=f286e980&scoped=true"
import script from "./OrganisationSignUp.vue?vue&type=script&lang=js"
export * from "./OrganisationSignUp.vue?vue&type=script&lang=js"
import style0 from "./OrganisationSignUp.vue?vue&type=style&index=0&id=f286e980&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f286e980",
  null
  
)

export default component.exports